<script lang="ts" setup>
import { computed } from 'vue'

const props = defineProps({
  modelValue: {
    type: Boolean,
    required: true,
  },
  width: {
    type: [String, Number],
    default: 448,
  },
  title: {
    type: String,
    default: '',
  },
  class: {
    type: String,
    default: '',
  },
  persistent: {
    type: Boolean,
    default: true,
  },
  hideCloseButton: {
    type: Boolean,
    default: false,
  },
  customClass: {
    type: String,
    default: '',
  },
  opacity: {
    type: Number,
    default: 0.8,
  },
})

const emit = defineEmits(['update:modelValue', 'onButtonClose'])

const modalVisible = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emit('update:modelValue', value)
  },
})

const onClose = () => {
  emit('update:modelValue', false)
  emit('onButtonClose')
}
</script>
<template>
  <VDialog
    v-model="modalVisible"
    :width="props.width"
    content-class="base-modal"
    :persistent="props.persistent"
    no-click-animation
    :z-index="2000"
    :opacity="props.opacity"
  >
    <VCard
      :class="{
        [props.class]: true,
        'base-modal-body': true,
        [props.customClass]: true,
      }"
    >
      <VBtn
        v-if="!props.hideCloseButton"
        class="base-modal-body__close"
        icon="icon-close-popup"
        variant="text"
        size="small"
        @click="onClose"
      />
      <VCardTitle v-if="props.title">
        {{ props.title }}
      </VCardTitle>
      <slot />
      <slot name="footer" />
    </VCard>
  </VDialog>
</template>
<style scoped></style>
